+function ($) {
    "use strict";

    if ($.jedeye !== undefined) {
        return;
    }

    if ($.jedeye === undefined)
        $.jedeye = {}

    if ($.jedeye.foundation === undefined)
        $.jedeye.foundation = {}

    $.jedeye.foundation._proxyCounter = 0

    var Base = function () {
        this.proxiedMethods = {}
    }

    Base.prototype.dispose = function () {
        for (var key in this.proxiedMethods) {
            this.proxiedMethods[key] = null
        }

        this.proxiedMethods = null
    }

    Base.prototype.proxy = function (method) {
        if (method.jedeyeProxyId === undefined) {
            $.jedeye.foundation._proxyCounter++
            method.jedeyeProxyId = $.jedeye.foundation._proxyCounter
        }

        if (this.proxiedMethods[method.jedeyeProxyId] !== undefined)
            return this.proxiedMethods[method.jedeyeProxyId]

        this.proxiedMethods[method.jedeyeProxyId] = method.bind(this)
        return this.proxiedMethods[method.jedeyeProxyId]
    }

    $.jedeye.foundation.base = Base;

    var ControlUtils = {
        markDisposable: function (el) {
            el.setAttribute('data-disposable', '')
        },

        disposeControls: function (container) {
            var controls = container.querySelectorAll('[data-disposable]')

            for (var i = 0, len = controls.length; i < len; i++)
                $(controls[i]).triggerHandler('dispose-control')

            if (container.hasAttribute('data-disposable'))
                $(container).triggerHandler('dispose-control')
        }
    }

    $.jedeye.foundation.controlUtils = ControlUtils;

    $(document).on('ajaxBeforeReplace', function (ev) {
        $.jedeye.foundation.controlUtils.disposeControls(ev.target)
    })

}(window.jQuery);
